/**
 * @generated SignedSource<<e9a4ee5d12e8e50d602a85e02bb7ce77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Slide_slide",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SlideContainer_slide"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SlideCaption_slide"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SlideOverlay_slide"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ResponsiveImage",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ResponsiveImage_image"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Slide",
  "abstractKey": null
};

node.hash = "7ff627f9218f6a827e698139a80f07a6";

module.exports = node;
